export default "__VITE_ASSET__DdgC6zfN__"